import type {
  Plan,
  PricingPlansSectionProps,
  TaxDetails,
  CurrencySettings,
} from '../../exported-components/pricing-plans-section';
import {
  EDisplayTaxType,
  EPlanDescription,
} from '../../exported-components/pricing-plans-section';
import type { i18n } from '@wix/wix-i18n-config';

export const mockCurrencySettings: CurrencySettings = {
  code: 'USD',
  symbol: 'US&#36;',
};
export const mockTaxSettings: TaxDetails = {
  showPriceWithTax: true,
  displayTaxType: EDisplayTaxType.VAT,
};
export const companyName = 'my company';
export const plans: Plan[] = [
  {
    name: 'Free Plan',
    description: {
      descriptionType: EPlanDescription.CUSTOM_TEXT,
      costumeText:
        'Free for up to 100 email contacts dozens of targeting rules unlimited pop ups, flyouts, and more',
      benefits: [],
    },
    title: 'Free',
    isFree: true,
  },
  {
    name: 'Starter Plan',
    description: {
      descriptionType: EPlanDescription.BENEFITS,
      benefits: [
        'Free for up to 100 email contacts',
        'Dozens of targeting rules',
        'Unlimited pop ups, flyouts, and more',
      ],
    },
    monthlyPrice: '24.49',
    yearlyPrice: '22.49',
    isFree: false,
  },
  {
    name: 'Pro Plan',
    description: {
      descriptionType: EPlanDescription.BENEFITS,
      benefits: [
        'Free for up to 100 email contacts',
        'Dozens of targeting rules',
        'Unlimited pop ups, flyouts, and more',
      ],
    },
    monthlyPrice: '19.90',
    yearlyPrice: '17.90',
    isFree: false,
  },
  {
    name: 'No fixes fee Plan',
    description: {
      descriptionType: EPlanDescription.BENEFITS,
      benefits: [
        'Unlimited product export',
        'Advanced settings available in the app',
        'Large amount of product attributes',
        'Auto-create Pinterest product groups',
      ],
    },
    title: 'Agency',
    meterdBilling: {
      outline: '$0.3 per mail',
      baseFee: '19.90',
    },
    isFree: false,
  },
];

export const plansWithoutYearly: Plan[] = [
  {
    name: 'Free Plan',
    description: {
      descriptionType: EPlanDescription.CUSTOM_TEXT,
      costumeText:
        'Free for up to 100 email contacts dozens of targeting rules unlimited pop ups, flyouts, and more',
      benefits: [],
    },
    title: 'Free',
    isFree: true,
  },
  {
    name: 'Starter Plan',
    description: {
      descriptionType: EPlanDescription.BENEFITS,
      benefits: [
        'Free for up to 100 email contacts',
        'Dozens of targeting rules',
        'Unlimited pop ups, flyouts, and more',
      ],
    },
    monthlyPrice: '24.49',
    isFree: false,
  },

  {
    name: 'Pro Plan',
    description: {
      descriptionType: EPlanDescription.BENEFITS,
      benefits: [
        'Free for up to 100 email contacts',
        'Dozens of targeting rules',
        'Unlimited pop ups, flyouts, and more',
      ],
    },
    monthlyPrice: '19.90',
    isFree: false,
  },
  {
    name: 'No fixes fee Plan',
    description: {
      descriptionType: EPlanDescription.BENEFITS,
      benefits: [
        'Unlimited product export',
        'Advanced settings available in the app',
        'Large amount of product attributes',
        'Auto-create Pinterest product groups',
      ],
    },
    title: 'Agency',
    meterdBilling: {
      outline: '$0.3 per mail',
      baseFee: '19.90',
    },
    isFree: false,
  },
];

export const pricingMockPricingPlansSectionProps = {
  appId: 'ec60b0a2-c853-4031-a63f-48a30524a57b',
  externalPricingPageUrl: 'link',
  isExternalPricing: true,
  trialDays: 3,
  tax: mockTaxSettings,
  currencySettings: mockCurrencySettings,
  companyName,
  plans,
};
export const getPricingMockPricingPlansSectionProps = (
  i18n: i18n,
  isMobile?: boolean,
): PricingPlansSectionProps => {
  return {
    ...pricingMockPricingPlansSectionProps,
    isMobile: !!isMobile,
    i18n,
  };
};
